export class UsersService {
  public async GetUsersByRoleId(id: number): Promise<any> {
    try {
      const options: RequestInit = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/GetUsers`, options);

      return Promise.resolve(await request.json());
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async GetUsersFromUserInRolesTable(): Promise<any> {
    try {
      const options: RequestInit = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/GetUsersFromUserInRolesTable?`, options);

      return Promise.resolve(await request.json());
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async GetUserByNameOrEmail(text) {
    const options: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    };

    const request = await fetch(`${process.env.SERVER_URL}/api/user/GetUserByQueryText?queryText=${encodeURI(text)}`, options);
    const result = await request.json();

    // return Promise.resolve(await request.json());

    return result.map((user) => {
      return {
        ...user,
        primaryText: user.Name,
        secondaryText: user.LoginName,
      };
    });
  }

  
  public async RemoveUser(user): Promise<any> {
    try {
      const options: RequestInit = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(user),
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/RemoveUser`, options);
      return Promise.resolve(await request);
    } catch (err) {
      return Promise.reject(err);
    }
  }
  public async SaveUser(user): Promise<any> {
    try {
      const options: RequestInit = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(user),
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/SaveUser`, options);
      return Promise.resolve(await request);
    } catch (err) {
      return Promise.reject(err);
    }
  }
  public async SetNewPassword(user): Promise<any> {
    try {
      const options: RequestInit = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(user),
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/SetNewPassword`, options);
      return Promise.resolve(await request);
    } catch (err) {
      return Promise.reject(err);
    }
  }
  
  public async EnableUser(userName): Promise<any> {
    try {
      const options: RequestInit = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body:null,
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/EnableUser?userName=${userName}`, options);
      return Promise.resolve(await request);
    } catch (err) {
      return Promise.reject(err);
    }
  }
  public async DisableUser(userName): Promise<any> {
    try {
      const options: RequestInit = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body:null,
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/DisableUser?userName=${userName}`, options);
      return Promise.resolve(await request);
    } catch (err) {
      return Promise.reject(err);
    }
  }
  
  public async CreateUser(user): Promise<any> {
    try {
      const options: RequestInit = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(user),
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/CreateUser`, options);
      return Promise.resolve(await request.json());
    } catch (err) {
      return Promise.reject(err);
    }
  }
  
  public async DeleteUser(userId: number): Promise<any> {
    try {
      const options: RequestInit = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      };

      const request = await fetch(`${process.env.SERVER_URL}/api/user/DeleteUser?userId=${userId}`, options);
      return Promise.resolve(await request.json());
    } catch (err) {
      return Promise.reject(err);
    }
  }
}
